import { useState } from "react";
import "../../_css/DeletePopup.css"; // we'll define styles
import { deleteAuthToken, notifyError } from "../../utils/helper";
import { useDispatch } from "react-redux";
import { startLoader, stopLoader } from "../../_store/reducers/loaderReducer";
import { deleteAccount } from "../../requests";
import { useNavigate } from "react-router-dom";

export default function DeleteAccountPopup({fn}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  

  const handleDelete = async () => {

    dispatch(startLoader())

   try {

    const res = await deleteAccount();
    if (res.status < 400) {
      notifyError("Account deleted successfully.");
    
      fn(); // Close the popup

      deleteAuthToken()

      navigate("/login"); 
      
    }
    
   } catch (error) {
      console.error("Error deleting account:", error);  
      notifyError("Failed to delete account. Please try again later.");
    
   }finally{
    dispatch(stopLoader())
   }
   
  };

  return (
    <div>
     

      {/* Popup */}
      
        <div className="delete-popup-overlay">
          <div className="delete-popup">
            <h2>Are you sure?</h2>
            <p>This action cannot be undone. Your account will be permanently deleted.</p>
            <div className="delete-popup-actions">
              <button className="cancel-btn" onClick={() =>fn()}>
                Cancel
              </button>
              <button className="confirm-btn" onClick={handleDelete}>
                Yes, Delete
              </button>
            </div>
          </div>
        </div>
      
    </div>
  );
}
